// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-gradient: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);
  --sidebar-blur: blur(16px);
  --card-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --slate-50: #f8fafc;
  --slate-100: #f1f5f9;
  --slate-200: #e2e8f0;
  --slate-300: #cbd5e1;
  --slate-800: #1e293b;
}

body {
  background-color: var(--slate-50) !important;
  color: var(--slate-800);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Custom AppBar Styles */
.my-appbar {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: var(--sidebar-blur);
  -webkit-backdrop-filter: var(--sidebar-blur);
  border-bottom: 1px solid var(--slate-200) !important;
}

/* Premium Card Design */
.MuiCard-root.custom-card {
  border-radius: 12px;
  border: 1px solid var(--slate-200);
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  background-color: #ffffff;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  margin-bottom: 24px;
}

.MuiCard-root.custom-card:hover {
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
}

.MuiCard-root.custom-card > .MuiCardHeader-root {
  border-bottom: 1px solid var(--slate-100);
  padding: 16px 20px;
  background-color: var(--slate-50);
}

.MuiCard-root.custom-card > .MuiCardHeader-root .MuiCardHeader-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--slate-800);
}

/* Labs and Results */
.result-card {
  height: auto;
  min-height: 90px;
  padding: 12px 16px;
  background-color: #ffffff;
  border: 1px solid var(--slate-200);
  border-top: 4px solid #4f46e5;
  border-radius: 12px;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  transition: all 0.2s;
}

.result-card:hover {
  border-top-width: 6px;
  box-shadow: var(--card-shadow);
}

.result-test-name {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
  color: var(--slate-800);
}

.result-value {
  font-size: 13px;
  color: #4f46e5;
  font-weight: 600;
}

/* Modern Filters */
.MuiPaper-root.filter-wrapper {
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid var(--slate-200);
  padding: 12px 20px;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.MuiButtonBase-root.btn-record-filter {
  font-size: 13px;
  background-color: var(--slate-50);
  border: 1px solid var(--slate-200);
  color: var(--slate-800);
  border-radius: 8px;
  transition: all 0.2s;
}

.MuiButtonBase-root.btn-record-filter:hover {
  background-color: var(--slate-100);
  border-color: var(--slate-300);
}

/* Authentication Inputs */
.auth-code-input__input {
  width: 52px;
  height: 52px;
  border-radius: 10px;
  border: 2px solid var(--slate-200);
  font-size: 1.25rem;
  font-weight: 600;
  transition: all 0.2s;
}

.auth-code-input__input.focused {
  border-color: #4f46e5;
  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
  outline: none;
}

/* Custom Tabs */
.my-tab .MuiTab-root {
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  text-transform: capitalize;
  min-height: 48px;
}

.my-tab .Mui-selected {
  color: #4f46e5 !important;
  font-weight: 600;
}

.my-tab .MuiTabs-indicator {
  height: 3px;
  border-radius: 3px;
  background-color: #4f46e5;
}

/* Helpers */
.text-grey {
  color: #64748b;
}

.glass-morphism {
  background: rgba(255, 255, 255, 0.7);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.premium-gradient-bg {
  background: var(--primary-gradient);
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,qEAAqE;EACrE,0BAA0B;EAC1B,+EAA+E;EAC/E,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,uBAAuB;EACvB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,4CAA4C;EAC5C,oDAAoD;AACtD;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,kCAAkC;EAClC,yEAAyE;EACzE,yBAAyB;EACzB,mEAAmE;EACnE,mBAAmB;AACrB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,6BAA6B;EAC7B,mBAAmB;EACnB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,kCAAkC;EAClC,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');\n\n:root {\n  --primary-gradient: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%);\n  --sidebar-blur: blur(16px);\n  --card-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --slate-50: #f8fafc;\n  --slate-100: #f1f5f9;\n  --slate-200: #e2e8f0;\n  --slate-300: #cbd5e1;\n  --slate-800: #1e293b;\n}\n\nbody {\n  background-color: var(--slate-50) !important;\n  color: var(--slate-800);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Custom AppBar Styles */\n.my-appbar {\n  background: rgba(255, 255, 255, 0.8) !important;\n  backdrop-filter: var(--sidebar-blur);\n  -webkit-backdrop-filter: var(--sidebar-blur);\n  border-bottom: 1px solid var(--slate-200) !important;\n}\n\n/* Premium Card Design */\n.MuiCard-root.custom-card {\n  border-radius: 12px;\n  border: 1px solid var(--slate-200);\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n  background-color: #ffffff;\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  margin-bottom: 24px;\n}\n\n.MuiCard-root.custom-card:hover {\n  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n}\n\n.MuiCard-root.custom-card > .MuiCardHeader-root {\n  border-bottom: 1px solid var(--slate-100);\n  padding: 16px 20px;\n  background-color: var(--slate-50);\n}\n\n.MuiCard-root.custom-card > .MuiCardHeader-root .MuiCardHeader-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--slate-800);\n}\n\n/* Labs and Results */\n.result-card {\n  height: auto;\n  min-height: 90px;\n  padding: 12px 16px;\n  background-color: #ffffff;\n  border: 1px solid var(--slate-200);\n  border-top: 4px solid #4f46e5;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  transition: all 0.2s;\n}\n\n.result-card:hover {\n  border-top-width: 6px;\n  box-shadow: var(--card-shadow);\n}\n\n.result-test-name {\n  font-weight: 600;\n  font-size: 14px;\n  margin-bottom: 4px;\n  color: var(--slate-800);\n}\n\n.result-value {\n  font-size: 13px;\n  color: #4f46e5;\n  font-weight: 600;\n}\n\n/* Modern Filters */\n.MuiPaper-root.filter-wrapper {\n  background-color: #ffffff;\n  border-radius: 12px;\n  border: 1px solid var(--slate-200);\n  padding: 12px 20px;\n  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n}\n\n.MuiButtonBase-root.btn-record-filter {\n  font-size: 13px;\n  background-color: var(--slate-50);\n  border: 1px solid var(--slate-200);\n  color: var(--slate-800);\n  border-radius: 8px;\n  transition: all 0.2s;\n}\n\n.MuiButtonBase-root.btn-record-filter:hover {\n  background-color: var(--slate-100);\n  border-color: var(--slate-300);\n}\n\n/* Authentication Inputs */\n.auth-code-input__input {\n  width: 52px;\n  height: 52px;\n  border-radius: 10px;\n  border: 2px solid var(--slate-200);\n  font-size: 1.25rem;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.auth-code-input__input.focused {\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);\n  outline: none;\n}\n\n/* Custom Tabs */\n.my-tab .MuiTab-root {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #64748b;\n  text-transform: capitalize;\n  min-height: 48px;\n}\n\n.my-tab .Mui-selected {\n  color: #4f46e5 !important;\n  font-weight: 600;\n}\n\n.my-tab .MuiTabs-indicator {\n  height: 3px;\n  border-radius: 3px;\n  background-color: #4f46e5;\n}\n\n/* Helpers */\n.text-grey {\n  color: #64748b;\n}\n\n.glass-morphism {\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.premium-gradient-bg {\n  background: var(--primary-gradient);\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
